import i18n from '@/plugins/i18n';
import conf from '@/util/conf';

const locales = [
  {
    text: 'Italiano',
    value: 'it_IT',
    flag: 'it.svg'
  },
  {
    text: 'English',
    value: 'en_US',
    flag: 'en.svg'
  },
  {
    text: 'Polski',
    value: 'pl_PL',
    flag: 'pl.svg'
  },
  {
    text: 'Deutsch',
    value: 'de_DE',
    flag: 'de.svg'
  },
  // FIXME lang fr not needed (?)
  /*
  {
    text: 'Français',
    value: 'fr',
    flag: 'fr.svg'
  }
  */
];

const initialState = {
  locale: conf.value('VUE_APP_I18N_LOCALE'),
};

export const locale = {
  namespaced: true,

  state: initialState,

  actions: {
    setLocale: ({ commit }, localeCode) => {
      commit('mutateLocale', localeCode);
      i18n.locale = localeCode;
    }
  },

  mutations: {
    mutateLocale: (state, localeCode) => {
      state.locale = localeCode;
    }
  },

  getters: {
    locale(state) {
      return state.locale;
    },

    locales() {
      return locales;
    }
  }
};
